import React from 'react';
import { IExamCardPageProps } from './ExamCardPage.types';
import { ExamCardContainer } from '../../containers/ExamCardContainer/ExamCardContainer';

const ExamCardPage: React.FC<IExamCardPageProps> = ({ match }: IExamCardPageProps) => {
  return <ExamCardContainer routeParams={match.params} />;
};

export default ExamCardPage;
